import PropTypes from 'prop-types';
import {
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Tooltip
} from '@mui/material';
import { MagnifyingGlass, X } from '@phosphor-icons/react';
import './LibrarySearchInput.css';

const LibrarySearchInput = ({
  id,
  name,
  value,
  placeholder,
  hint,
  clearLabel,
  onChange,
  onClear
}) => (
  <div className='library-search-input-wrapper'>
    <OutlinedInput
      id={id}
      name={name}
      type='text'
      className='library-search-input'
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      fullWidth
      startAdornment={
        <InputAdornment position='start'>
          <MagnifyingGlass size={18} aria-hidden='true' />
        </InputAdornment>
      }
      endAdornment={
        value ? (
          <InputAdornment position='end'>
            <Tooltip title={clearLabel} placement='top'>
              <IconButton
                className='library-search-input__clear'
                aria-label={clearLabel}
                size='small'
                edge='end'
                onClick={onClear}
              >
                <X size={16} aria-hidden='true' />
              </IconButton>
            </Tooltip>
          </InputAdornment>
        ) : null
      }
    />
    {hint && <FormHelperText>{hint}</FormHelperText>}
  </div>
);

LibrarySearchInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hint: PropTypes.string,
  clearLabel: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired
};

export default LibrarySearchInput;
